import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "placeholder"];
import React from "react";
var __jsx = React.createElement;
import UploadIllustration from "@/components/Upload/components/UploadIllustration";
import { useTranslation } from "@i18n";
import styles from "../styles/MultiFileUploadPlaceholder.module.css";
var MultiFileUploadPlaceholder = function MultiFileUploadPlaceholder(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    placeholder = _ref.placeholder,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(styles.container, " ").concat(className)
  }, other), /*#__PURE__*/React.createElement("div", {
    className: styles.placeholder
  }, placeholder || t("upload_file", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(UploadIllustration, null)));
};
export default MultiFileUploadPlaceholder;